
import DodoneContext from 'app/dodones/Context';
import { useContext, useState, useCallback } from "react"
import Overlay from 'app/components/Overlay'

export default ({ children, header = '', close, ...props }) => {
  return <Overlay { ...props }>
           <div className="p-8 position-fixed inset-0 fcol">
             <div className="rounded bg-white flex-1 fcol text-black">
               <div className="p-d border-b-gray-500 frow items-center">
                 <div className="flex-1">
                   { header }
                 </div>
                 <i className="ph ph-x" onClick={ close } />
               </div>
               <div className="p-d fcol flex-1">
                 { children }
               </div>
             </div>
           </div>
         </Overlay>
}
